import { render, staticRenderFns } from "./ChangeReview.vue?vue&type=template&id=597be1ee"
import script from "./ChangeReview.vue?vue&type=script&lang=js"
export * from "./ChangeReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports